import { Link } from "react-router-dom";

const FULL_LOGO = "https://customer-assets-lqy194kg.emergentagent.net/job_jobprint-system/artifacts/1wh6fqce_PNGFullCropped-WHMCS.webp";

export function Logo({ to = "/" }) {
  return (
    <Link to={to} className="inline-flex items-center group" data-testid="logo-link">
      <img src={FULL_LOGO} alt="Borrow A Geek — The nerd you need... indeed!" className="h-8 sm:h-10 w-auto object-contain" />
    </Link>
  );
}
